var _g, _rect, _g2, _rect2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternelSalesOnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14858_71567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.68629 0 4 2.68629 4 6V34C4 37.3137 6.68629 40 10 40H38C41.3137 40 44 37.3137 44 34V22.8445C43.9118 22.8527 43.8225 22.8569 43.7321 22.8569C42.1542 22.8569 40.875 21.5777 40.875 19.9997C40.875 18.4218 42.1542 17.1426 43.7321 17.1426C43.8225 17.1426 43.9118 17.1468 44 17.155V6C44 2.68629 41.3137 0 38 0H10Z",
    fill: "#04B7B1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14858_71567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14858_71567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 22V15.5L26 12L21 15.5V17H19V14.5L26 9.5L33 14.5V22H31ZM26.5 16H27.5V15H26.5V16ZM24.5 16H25.5V15H24.5V16ZM26.5 18H27.5V17H26.5V18ZM24.5 18H25.5V17H24.5V18ZM19 26.5L25.95 28.4L31.9 26.55C31.8167 26.4 31.6958 26.2708 31.5375 26.1625C31.3792 26.0542 31.2 26 31 26H25.95C25.5 26 25.1417 25.9833 24.875 25.95C24.6083 25.9167 24.3333 25.85 24.05 25.75L21.725 24.975L22.275 23.025L24.3 23.7C24.5833 23.7833 24.9167 23.85 25.3 23.9C25.6833 23.95 26.25 23.9833 27 24C27 23.8167 26.9458 23.6417 26.8375 23.475C26.7292 23.3083 26.6 23.2 26.45 23.15L20.6 21H19V26.5ZM13 30V19H20.6C20.7167 19 20.8333 19.0125 20.95 19.0375C21.0667 19.0625 21.175 19.0917 21.275 19.125L27.15 21.3C27.7 21.5 28.1458 21.85 28.4875 22.35C28.8292 22.85 29 23.4 29 24H31C31.8333 24 32.5417 24.275 33.125 24.825C33.7083 25.375 34 26.1 34 27V28L26 30.5L19 28.55V30H13ZM15 28H17V21H15V28Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_14858_71567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_14858_71567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 22V15.5L26 12L21 15.5V17H19V14.5L26 9.5L33 14.5V22H31ZM26.5 16H27.5V15H26.5V16ZM24.5 16H25.5V15H24.5V16ZM26.5 18H27.5V17H26.5V18ZM24.5 18H25.5V17H24.5V18ZM19 26.5L25.95 28.4L31.9 26.55C31.8167 26.4 31.6958 26.2708 31.5375 26.1625C31.3792 26.0542 31.2 26 31 26H25.95C25.5 26 25.1417 25.9833 24.875 25.95C24.6083 25.9167 24.3333 25.85 24.05 25.75L21.725 24.975L22.275 23.025L24.3 23.7C24.5833 23.7833 24.9167 23.85 25.3 23.9C25.6833 23.95 26.25 23.9833 27 24C27 23.8167 26.9458 23.6417 26.8375 23.475C26.7292 23.3083 26.6 23.2 26.45 23.15L20.6 21H19V26.5ZM13 30V19H20.6C20.7167 19 20.8333 19.0125 20.95 19.0375C21.0667 19.0625 21.175 19.0917 21.275 19.125L27.15 21.3C27.7 21.5 28.1458 21.85 28.4875 22.35C28.8292 22.85 29 23.4 29 24H31C31.8333 24 32.5417 24.275 33.125 24.825C33.7083 25.375 34 26.1 34 27V28L26 30.5L19 28.55V30H13ZM15 28H17V21H15V28Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14858_71567",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14858_71567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14858_71567",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternelSalesOnIcon);
export default __webpack_public_path__ + "static/media/InternelSalesOnIcon.2a84a32a4b4f9bf5fba76136343a312b.svg";
export { ForwardRef as ReactComponent };